// extracted by css-extract-rspack-plugin
export default {"u-margin-top-2.4":"csmIh","BreadCrumbWrapper":"yV7NE","SummaryDetailWrapper":"VFz9X","ContentWrapper":"g17Hb","ContentTabWrapper":"UrsdO"};